import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import styles from "./Bubble.local.scss";

export default class BubbleComponent extends PureComponent {
  static propTypes = {
    bubble: PropTypes.object.isRequired,
    onClickBubble: PropTypes.func
  };

  render() {
    const { bubble, onClickBubble } = this.props;
    // debugger;
    return (
      <div
        className={styles.bubble + " " + bubble.className}
        onClick={() => onClickBubble(bubble.scrollingTo)}
      >
        <img
          src={"/img/icons/" + bubble.icon + ".svg"}
          className={styles.icon}
          alt=""
        />
        <span className={styles.label}>{bubble.label}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Bubble/BubbleComponent.js